import Select from 'react-select';
import useTranslation from '../../hooks/useTranslations';

const SelectBox = ({
	options, defaultValue, currentValue, onChange, placeholder, width, maxHeight, menuPlacement = 'auto', disabled = false, field, theme = 'blue', error = false, fieldName = '', label = '', labelClasses = '', showLabel = false, maxOptions, isMulti = false,
}) => {
	const t = useTranslation();
	// const currentValue = options.filter((option) => option.value === currentValueId);

	const backgroundColor = theme === 'white' ? 'white' : '#295a83';
	const color = theme === 'white' ? 'rgb(68, 68, 68)' : 'white';
	const borderColor = error ? 'red' : 'transparent';
	const border = theme === 'white' ? `1px ${borderColor} solid` : 'none';
	const height = theme === 'white' ? 37 : 40;
	const marginTop = theme === 'white' ? '4px' : 0;
	const paddingLeft = theme === 'white' ? 9 : 20;

	const customStyles = {
		option: (provided, state) => ({
			...provided,
			color: state.isSelected ? 'white' : 'black',
			paddingLeft: paddingLeft + 3,
			paddingRight: 50,
			paddingTop: 10,
			paddingBottom: 10,
			backgroundColor: state.isSelected ? '#295a83' : 'white',
			fontSize: '0.875rem',
			lineHeight: 1.4,
			borderRadius: 0,
			borderBottom: '1px solid #f4f4f4',
			'&:hover': {
				backgroundColor: '#295a83',
				color: 'white',
			},
			outline: 'none',
		}),
		container: (provided) => ({
			...provided,
			border: 'none',
			outline: 'none',
			marginTop,
		}),
		control: (provided, state) => ({
			...provided,
			width,
			// height,
			minHeight: height,
			border,
			backgroundColor: !disabled ? backgroundColor : 'rgb(229, 231, 235)',
			borderRadius: 0,
			'&:hover': {
				border,
			},
			outline: 'none',
			boxShadow: state.menuIsOpen ? 'rgba(255, 255, 255, 0.898) 0px 0px 0px 0px, rgba(8, 16, 123, 0.898) 0px 0px 0px 1.79624px, rgba(0, 0, 0, 0) 0px 0px 0px 0px' : 'none',
		}),
		singleValue: (provided) => ({
			...provided,
			color: !disabled ? color : 'rgb(68, 68, 68)',
			backgroundColor: !disabled ? backgroundColor : 'rgb(229, 231, 235)',
			textAlign: 'left',
			paddingLeft,
			fontSize: '0.875rem',
			width: '100%',
		}),
		multiValue: (provided) => ({
			...provided,
			color: !disabled ? color : 'rgb(68, 68, 68)',
			backgroundColor: 'rgb(229, 231, 235)',
		}),
		multiValueLabel: (provided) => ({
			...provided,
			fontSize: '0.875rem',
		}),
		multiValueRemove: (provided) => ({
			...provided,
			display: disabled ? 'none' : 'flex',
			// '&:hover': {
			// 	backgroundColor: '#e6000a',
			// 	color: 'white',
			// },
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			color: !disabled ? color : 'rgb(229, 231, 235)',
			padding: 0,
			paddingRight: 10,
			'&:hover': {
				color,
			},
		}),
		clearIndicator: (provided) => ({
			...provided,
			padding: 7,
		}),
		indicatorSeparator: () => ({
		}),
		placeholder: (provided) => ({
			...provided,
			color: '#a6a6a6',
			backgroundColor: !disabled ? backgroundColor : 'rgb(229, 231, 235)',
			textAlign: 'left',
			paddingLeft,
			fontSize: '0.875rem',
			width: '100%',
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: 0,
			backgroundColor: !disabled ? backgroundColor : 'rgb(229, 231, 235)',
		}),
		menuList: (provided) => ({
			...provided,
			maxHeight,
			padding: 0,
			borderRadius: 0,
			border: 'none',
		}),
		menu: (provided) => ({
			...provided,
			padding: 0,
			borderRadius: 0,
			border: 'none',
			marginTop: 5,
			boxShadow: '3px 4px 5px -5px rgba(0,0,0,0.75)',
		}),
		noOptionsMessage: (provided) => ({
			...provided,
			textAlign: 'left',
		}),
	};

	const maxedOptions = maxOptions && currentValue && currentValue.length === maxOptions;
	const keepMenuOpenOnSelect = !(currentValue && currentValue.length + 1 === (maxOptions ?? options.length));

	return (
		<span>
			<label htmlFor={fieldName} className={`${showLabel ? `block mx-1 text-oly-gray-darkest ${labelClasses || 'text-[0.875rem]'}` : 'sr-only'}`}>
				{label}
			</label>
			<Select
				options={maxedOptions ? [] : options}
				defaultValue={defaultValue}
				value={currentValue}
				onChange={(value) => onChange(value)}
				styles={customStyles}
				placeholder={!disabled && placeholder}
				isSearchable={false}
				menuPlacement={menuPlacement}
				isDisabled={disabled}
				{...field}
				isMulti={isMulti}
				closeMenuOnSelect={isMulti ? !keepMenuOpenOnSelect : true}
				noOptionsMessage={() => (maxedOptions ? t('webapp_selectbox_max') : t('webapp_selectbox_empty'))}
			/>
		</span>
	);
};

export default SelectBox;
